// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { MedplumClient } from '@medplum/core';
import type { Patient } from '@medplum/fhirtypes';
import type { AppointmentTypeDefinition, BookAppointmentResult } from '@polarissleep/scheduling';
import { bookAppointment as sharedBookAppointment } from '@polarissleep/scheduling';
import { getProviderAppEnvConfig } from '../config/env';
import { botIdentifier } from '../lib/bot-identifier';
import { withTenantScope } from '../utils/tenant';

interface BookAppointmentParams {
  /** The patient being booked — required explicitly because provider-app profile is a Practitioner */
  patient: Patient;
  slotId: string;
  appointmentTypeCode: string;
  providerId: string;
  start: string;
  end: string;
  /** Pre-resolved type definition — skips redundant CodeSystem fetch if provided */
  appointmentType?: AppointmentTypeDefinition;
}

export async function bookAppointment(
  medplum: MedplumClient,
  params: BookAppointmentParams
): Promise<BookAppointmentResult> {
  throw new Error('Legacy appointment booking is disabled. Select a V2 availability slot and try again.');
  const result = await sharedBookAppointment(medplum, {
    ...params,
    insuranceDeferredBillingEnabled: getProviderAppEnvConfig().insuranceDeferredBillingEnabled,
    allowDuplicateType: true,
    decorate: withTenantScope as <T extends { resourceType: string }>(r: T) => T,
  });

  await medplum.executeBot(
    botIdentifier('create-zoom-meetings'),
    { appointmentId: result.appointmentId },
    'application/json'
  );

  return result;
}
